export enum GenServiceProductType {
    SELLING = 'SELLING',
    RENEWAL = 'RENEWAL',
    FLEET = 'FLEET',
    API_SELLING = 'API_SELLING',
    API_RENEWAL = 'API_RENEWAL',
}
